function Game() {
  this.game_id = '';
  this.game_name = '';
  this.game_ver = '';
}

Game.prototype = {
  constructor: Game,
};

export default Game;



// WEBPACK FOOTER //
// ./src/common/js/model/Game.js